var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconTurquoise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.5C4.25315 0.5 0 4.75315 0 10C0 15.2469 4.25315 19.5 9.5 19.5C14.7469 19.5 19 15.2469 19 10C19 4.75315 14.7469 0.5 9.5 0.5ZM9.5 14.75C8.9756 14.75 8.55 14.3244 8.55 13.8V10C8.55 9.4756 8.9756 9.05 9.5 9.05C10.0244 9.05 10.45 9.4756 10.45 10V13.8C10.45 14.3244 10.0244 14.75 9.5 14.75ZM9.975 7.15H9.025C8.7628 7.15 8.55 6.9372 8.55 6.675V5.725C8.55 5.4628 8.7628 5.25 9.025 5.25H9.975C10.2372 5.25 10.45 5.4628 10.45 5.725V6.675C10.45 6.9372 10.2372 7.15 9.975 7.15Z",
    fill: "#8AC3BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconTurquoise);
export default __webpack_public_path__ + "static/media/info_icon_turquoise.c39bb0ebdcb72b2df13fe8890c5e0105.svg";
export { ForwardRef as ReactComponent };